import { Alert } from 'antd';
import React from 'react';
import { TextAlertTypes } from '../../../config/constants/global.constants';
type TextAlertProps = {
  text: React.ReactNode;
  type?: TextAlertTypes;
  showIcon?: boolean;
  withClosebutton?: boolean;
  likeBanner?: boolean;
  description?: string;
  action?: React.ReactNode;
  style?: React.CSSProperties;
};

const TextAlert: React.FC<TextAlertProps> = ({
  text = '',
  type = TextAlertTypes.INFO,
  showIcon = false,
  withClosebutton = false,
  likeBanner = false,
  description = '',
  action = null,
  style = {},
}) => {
  return (
    <Alert
      message={text}
      type={type}
      showIcon={showIcon}
      closable={withClosebutton}
      banner={likeBanner}
      description={description}
      action={action}
      style={style}
    />
  );
};

export default TextAlert;
